import { Button, IconButton, Stack, Typography } from "@mui/material";
import LassoToggleButtons from "../../../../components/LassoToggleButtons";
import React from "react";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

interface Props {
    back: () => void;
    view: "sites" | "visits";
    field: string;
    description: string;
    setView: (newView: "sites" | "visits") => void;
    traverseVariables: (direction: "left" | "right") => void;
    isStaticInstrument?: boolean;
}

const FieldToolbar = (props: Props) => {
    return (
        <Stack gap={4} direction="row" justifyContent={'space-between'} alignItems={'center'} sx={{ width: '100%' }} paddingBottom={1}>
            <Button
                sx={{ margin: 2 }}
                variant="outlined"
                onClick={props.back}
                onMouseDown={(e) => e.preventDefault()}
            >
                Back
            </Button>
            <IconButton onClick={() => props.traverseVariables("left")}>
                <ChevronLeftIcon />
            </IconButton>
            <Stack direction={'column'} alignItems={'center'} flexGrow={1}>
                <Typography variant={"h5"} fontWeight={"bold"} textAlign={"center"}>{props.description}</Typography>
                <Typography variant={"subtitle1"}>{props.field}</Typography>
            </Stack>
            <IconButton onClick={() => props.traverseVariables("right")}>
                <ChevronRightIcon />
            </IconButton>
            <LassoToggleButtons
                value={props.view}
                onChange={(e, newValue) => {
                    if (newValue) {
                        props.setView(newValue)
                    }
                }}
                exclusive
                buttons={[
                    { label: "By Site", value: "sites", minWidth: '200px' },
                    { label: "By Visit", value: "visits", minWidth: '200px', disabled: props.isStaticInstrument }
                ]} />
        </Stack>
    );
}

export default FieldToolbar;